import { useSelector } from "react-redux";
import amountFormatter from "../utils/amountFormatter";

const Balance = () => {
	const { transactions } = useSelector((state) => state.transaction);

	const calculateIncome = (transactions) => {
		let income = 0;
		transactions.forEach((transaction) => {
			const { type, amount } = transaction;
			if (type === "income") {
				income += amount;
			} else {
				income -= amount;
			}
		});

		return income;
	};

	return (
		<div className="flex justify-center items-center sm:drop-shadow-lg">
			<div className="bg-green-700 w-full md:w-2/3 lg:w-1/2 xl:w-2/4 2xl:w-1/3 flex justify-between items-center px-6 h-[70px] sm:h-[100px]">
				<p className="text-lg sm:text-2xl text-white font-medium">
					Your Current Balance:{" "}
				</p>
				<div className="text-2xl sm:text-3xl font-semibold text-white">
					<span>৳</span>{" "}
					<span>
						{transactions?.length > 0
							? amountFormatter(calculateIncome(transactions))
							: 0}
					</span>
				</div>
			</div>
		</div>
	);
};

export default Balance;
